var _excluded = ["icon", "image", "text", "link"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { cover } from "polished";
import styled, { css } from "styled-components";
import useBreakpoint from "../../../hooks/useBreakpoint";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import IconAtm from "../../atoms/IconAtm";
import { cssTextAtm } from "../../atoms/TextAtm/TextAtm.styled";
import Link from "../../quarks/Link";
import Picture from "../../quarks/Picture";
var paddingSpace = 2;
var backgroundColor = "backgroundLight";
var breakpointValue = "medium";
var Container = styled.div.withConfig({
  componentId: "sc-1e0ptwe-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["", ";position:relative;border-radius:", ";background-color:", ";box-shadow:", ";&:hover{box-shadow:", ";}", "{width:100%;padding-top:100%;}", "{display:inline-flex;align-items:center;padding-right:", ";}"], transition("box-shadow"), getBorderRadius(theme, "large"), getColor(theme, backgroundColor), getBoxShadow(theme, "tiny"), getBoxShadow(theme, "small"), breakpoint("small", breakpointValue), breakpoint(breakpointValue), space(paddingSpace));
});
var IconWrapper = styled.div.withConfig({
  componentId: "sc-1e0ptwe-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["", "{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}", "{display:flex;position:relative;align-items:center;align-self:stretch;justify-content:center;margin-right:", ";padding:", ";&::after{content:\"\";position:absolute;right:0;width:", ";height:calc(100% - ", ");background-color:", ";}}"], breakpoint("small", breakpointValue), breakpoint(breakpointValue), space(paddingSpace), space(2), unit(1), space(1), getBorderColor(theme, backgroundColor, "low"));
});
var Text = styled(Link).withConfig({
  componentId: "sc-1e0ptwe-2"
})(["", ";text-decoration:none;", "{", ";font-size:0;}", "{&::after{", ";content:\"\";}}"], cssTextAtm({
  typography: "small2",
  onColor: backgroundColor
}), breakpoint("small", breakpointValue), cover(), breakpoint(breakpointValue), cover());
function IconButtonMol(_ref3) {
  var icon = _ref3.icon,
    image = _ref3.image,
    text = _ref3.text,
    link = _ref3.link,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var isMediumUp = useBreakpoint("medium");
  var iconJsx = image && /*#__PURE__*/React.createElement(Picture, {
    srcData: image
  });
  if (icon) {
    iconJsx = /*#__PURE__*/React.createElement(IconAtm, {
      icon: icon,
      sizeSpace: isMediumUp ? 4 : 6,
      color: "primary"
    });
  }
  return /*#__PURE__*/React.createElement(Container, restProps, /*#__PURE__*/React.createElement(IconWrapper, null, iconJsx), /*#__PURE__*/React.createElement(Text, link, text));
}
export default IconButtonMol;